/* eslint-disable no-mixed-operators */
/* eslint-disable array-callback-return */
import React, { Component } from "react";
import { imsLoader, crossIcon } from "../../assets";
import './GenAIAnsweringPreview.css'
import { LocationOrigin } from '../../utils/utilityServices';
import { withRouter, Link } from 'react-router-dom';
import axios from "axios";
import GenAIPreviewSidebar from '../GenAIAnswering2.0/GenAIPreviewSidebar';
import { GenAIAnsweringContext } from '../GenAIAnswering2.0/GenAIAnsweringContextProvider';
import { Authentication } from "../../utils/authenticationUtilityServices";

let _locationOrigin = LocationOrigin;
//_locationOrigin = "https://predev-ims.jnj.com";
let _timeoutTime = (1000 * (300));

class GenAIAnsweringWindowPreview extends Component {
    static contextType = GenAIAnsweringContext
    constructor(props) {
        super(props);
        this.state = {
            previewURL: '',
            apiURL: '',
            selectedSource: null,
            selectedPageNumber: [],
            isProcessing: true,
            PageNumber: 1,
            isMultiFiles: null,
            attachedFiles: [],
            DisplayString: [],
            isChangePage: false,
        }

    }
    componentDidMount = async () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        let eventid = this.props.match.params.id;
        let _id = queryParams.get("docid");
        let prviewObject = window[`${eventid}-${_id}`];
        if (prviewObject) {
            this.setState({
                selectedSource: prviewObject.selectedSource,
                selectedPageNumber: prviewObject.selectedPageNumber,
                isMultiFiles: prviewObject.isMultiFiles,
                attachedFiles: prviewObject.attachedFiles,
                PageNumber: prviewObject.selectedPageNumber[0],
                DisplayString: prviewObject.DisplayString,
                isRecommendation: prviewObject.isRecommendation,
            })
            let { isMultiFiles, selectedSource, selectedPageNumber } = prviewObject;
            let apiURL = "";
            if (isMultiFiles) {
                let { attachedFiles } = prviewObject;
                let filtersFile = attachedFiles.filter((singleFile => {
                    if (selectedSource.document_guid && singleFile.guid) {
                        return singleFile.guid === selectedSource.document_guid;
                    } else {
                        return singleFile.name === selectedSource.document_title;
                    }
                }))
                if (filtersFile.length > 0) {
                    let singleFile = filtersFile[0];
                    var url = URL.createObjectURL(singleFile);
                    if (false && (window.location.origin === "https://predev-ims.jnj.com" || window.location.origin === "http://localhost:3000")) {
                        await this.fetchHighlightDocumentUpload(prviewObject, singleFile)
                    } else {
                        this.setState({ previewURL: url }, async () => {
                            this.setState({ isProcessing: false })
                        })
                    }
                } else {
                    this.setState({ previewURL: "" }, async () => {
                        this.setState({ isProcessing: false })
                    })
                }
            } else {
                if (decodeURIComponent(selectedSource.download_url).includes("csID=29") || decodeURIComponent(selectedSource.download_url).includes("csID=31")) {
                    //var href = new URL(`https://ims.jnj.com${selectedSource.download_url}`);
                    var href = new URL(`${_locationOrigin}${selectedSource.download_url}`);
                    href.searchParams.set('connID', '7');
                    href.searchParams.set('csID', '50');
                    href.searchParams.set('fileType', 'pdf');
                    apiURL = href.toString();
                } else {
                    //apiURL = `https://ims.jnj.com${selectedSource.download_url}`
                    apiURL = `${_locationOrigin}${selectedSource.download_url}`
                }
                if (selectedSource.enclosureDocID && selectedSource.enclosureDocID.toString().trim()) {
                    apiURL += `&enclosureID=${selectedSource.enclosureDocID}`
                }
                this.setState({ apiURL: apiURL }, async () => {
                    //if (window.location.origin === "https://predev-ims.jnj.com" || window.location.origin === "http://localhost:3000") {
                    if (window.location.origin === "https://predev-ims.jnj.com" && false) {
                        await this.fetchHighlightDocument();
                    } else {
                        await this.fetchDocument();
                    }
                })
            }
        } else {
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        }

    }
    fetchHighlightDocument = async () => {
        const { apiURL, selectedSource, DisplayString } = this.state;
        const _headers = {}
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
            _headers['x-forward-auth'] = token;
        }
        let _body = {
            "download_url": apiURL,
            "contexts": selectedSource.contexts,
            "display_string": DisplayString
        }
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}highlight?threshold=0.85`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}highlight?threshold=0.85`;
        }
        await axios.post(
            url,
            _body,
            {
                headers: _headers,
                responseType: "blob",
                timeout: _timeoutTime,
            }
        ).then((response) => {
            console.log("Success API reponse");
            const data = new Blob([response.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(data)
            this.setState({ previewURL: url }, async () => {
                this.setState({ isProcessing: false })
            })
        }).catch((error) => {
            console.log(error);
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        });
    }
    fetchHighlightDocumentUpload = async (prviewObject, singleFile) => {
        const { apiURL, selectedSource, DisplayString } = this.state;
        console.log(singleFile)
        const formData = new FormData();
        formData.append('contexts', JSON.stringify(prviewObject.selectedSource.contexts))
        formData.append('display_string', JSON.stringify(prviewObject.DisplayString))
        formData.append('pdf_file', singleFile)
        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
            _headers['x-forward-auth'] = token;
        }
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}highlight/upload?threshold=0.85`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}highlight/upload?threshold=0.85`;
        }
        await axios.post(
            url,
            formData,
            {
                headers: _headers,
                responseType: "blob",
                timeout: _timeoutTime,
            }
        ).then((response) => {
            console.log("Success API reponse");
            const data = new Blob([response.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(data)
            this.setState({ previewURL: url }, async () => {
                this.setState({ isProcessing: false })
            })
        }).catch((error) => {
            console.log(error);
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        });
    }

    fetchDocument = async () => {
        const { apiURL } = this.state;
        const _headers = {}
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            apiURL,
            {
                headers: _headers,
                responseType: "blob",
            }
        ).then((response) => {
            const data = new Blob([response.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(data)
            this.setState({ previewURL: url }, async () => {
                this.setState({ isProcessing: false })
            })
        }).catch((error) => {
            console.log(error);
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        });
    }
    handleclickCitation = (pageNumber) => {
        let { isChangePage } = this.state;
        this.setState({ PageNumber: pageNumber, isChangePage: !isChangePage })
    }

    render() {

        let { isProcessing, PageNumber, previewURL, isMultiFiles, selectedSource, DisplayString, isRecommendation, isChangePage } = this.state;
        return (<div className="gen-ai-document-window-preview-wrapper">
            {isProcessing ? <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <img src={imsLoader} alt="Loading Filters" style={{ width: "10%", marginTop: "200px" }} />
            </div> : <>
                {previewURL ? <div className="gen-ai-document-window-preview-panel">
                    <object key={`"gen-ai-document-window-preview-panel-${PageNumber}-${isChangePage}`} data={`${previewURL}#page=${PageNumber}`} className={this.context.isCollapsedWindowPreviewInfo ? "gen-ai-document-window-preview-collapsed" : "gen-ai-document-window-preview-expand"} height="100%">
                        <p>Unable to display PDF file.</p>
                    </object>
                    <GenAIPreviewSidebar selectedSource={selectedSource} isMultiFiles={isMultiFiles}
                        DisplayString={DisplayString} handleclickCitation={this.handleclickCitation} isRecommendation={isRecommendation} />
                </div> : <div className="gen-ai-document-preview-error-panel">
                    <p>Unable to display PDF file.</p>
                </div>}
            </>
            }

        </div>)
    }
}
export default withRouter(GenAIAnsweringWindowPreview);
